import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { ProfileSelect } from "../../components/Dashboard/ProfileSelect";
import { Footer } from "../../components/Dashboard/Footer";
import { SideNavBar } from "../../components/SideNavBar";
import { CKEditor } from "ckeditor4-react";
import DataTable from "react-data-table-component";
import RolesTable from "../../components/userTable/RolesTable";
import { userRolesThunk } from "../../store/userRoles/Thunk";
import { MdDeleteOutline } from "react-icons/md";
import { GrView } from "react-icons/gr";
import { FiEdit2 } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";

export const PaymentHistory = ({ cookies }) => {
  const staffOptions = ["Overview (All)", "White Oak (Property Manager)"];
  const propertyOptions = ["Overview (All)", "New Heights", "Riverbridge"];

  let [showPropertyDropdown, setShowPropertyDropdown] = useState(false);
  let [propertyName, setPropertyName] = useState("Property 1");

  const userRoles = useSelector((state) => {
    return state?.UserRoles?.Roles?.data?.roles;
  });
  //   const status = useSelector((state) => {
  //     return state?.UserRoles?.status;
  //   });
  const dispatch = useDispatch();
  const handleContentScroll = (e) => {
    // let show = e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight;
    // if (show) setShowFooter(() => showFooter = show)
    // else setShowFooter(() => showFooter = false)
  };
  const handePropertyDropdown = () => {
    setShowPropertyDropdown(!showPropertyDropdown);
  };
  const handlePropertyName = (e) => {
    setPropertyName(e.target.innerHTML);
  };
  useEffect(() => {
    const jquery = document.createElement("script");
    jquery.src = "/assets/admin/js/jquery-3.6.0-min.js";
    jquery.async = true;
    document.body.appendChild(jquery);
    const bootstrap = document.createElement("script");
    bootstrap.src = "/assets/admin/js/bootstrap.min.js";
    bootstrap.async = true;
    document.body.appendChild(bootstrap);
    const main = document.createElement("script");
    main.src = "/assets/admin/js/main.js";
    main.async = true;
    document.body.appendChild(main);

    return () => {
      document.body.removeChild(jquery);
      document.body.removeChild(bootstrap);
      document.body.removeChild(main);
    };
  }, []);
  useEffect(() => {
    dispatch(userRolesThunk());
  }, []);
  const columns = [
    {
      name: "PO Number",
      selector: (row) => "Maintenance",
    },
    {
      name: "Line Item",
      selector: (row) => {
        return "General: Supplies";
      },
    },
    {
      name: "Type",
      selector: (row) => {
        return "Expenses";
      },
    },
    {
      name: "PREVIOUS_YEAR Balance",
      selector: (row) => {
        return "-$27,047.60";
      },
    },
    {
      name: "SELECTED_YEAR} Budget",
      selector: (row) => {
        return "-$40,000.00";
      },
    },
    {
      name: "Expenses to Date",
      selector: (row) => {
        return "-$21,298.44";
      },
    },
    {
      name: "Income to Date",
      selector: (row) => {
        return "-$60,251.54";
      },
    },
    {
      name: "Balance to Date",
      selector: (row) => {
        return "-$21,298.44";
      },
    },

    // {
    //   name: "Status",
    //   selector: (row) => row.is_active===1?"Active":"Inactive",
    // },
    {
      name: "Actions",
      cell: (row) => {
        return (
          <>
            <button
              class="bg-gray-300 py-1 mr-2  w-12 flex justify-center align-items-center rounded text-black-800"
              data-bs-toggle="modal"
              data-bs-target="#exampleModalLgView"
            >
              {/* <i class="fa-solid fa-eyes mr-6"></i> */}
              <span>
                <GrView />
              </span>
            </button>
            <button
              class="bg-gray-300 py-1 mr-2  w-12 flex justify-center align-items-center rounded text-black-800"
              data-bs-toggle="modal"
              data-bs-target="#exampleModalLg"
            >
              {/* <i class="fa-solid fa-pen mr-6"></i> */}
              <span>
                <FiEdit2 />
              </span>
            </button>
            <button class="bg-gray-300 py-1 mr-2  w-12 flex justify-center align-items-center rounded text-black-800">
              {/* <i class="fa-regular fa-trash mr-6"></i> */}
              <span>
                <MdDeleteOutline />
              </span>
            </button>
          </>
        );
      },
    },
  ];
  const [collapsed,setCollapsed] = useState(true)
const handleChildMessage = (message) => {
setCollapsed(message)
};
  return (
    <div className="main-dashboard">
      <Helmet>
        <link rel="stylesheet" href="/assets/admin/css/main.css" />
        <link
          rel="stylesheet"
          href="/assets/admin/css/fontawesome-all.min.css"
        />
        <link rel="stylesheet" href="/assets/admin/css/bootstrap.min.css" />
        <link rel="stylesheet" href="/assets/admin/css/slick.css" />
        <link rel="stylesheet" href="/assets/admin/css/responsive.css" />
      </Helmet>
      <SideNavBar active="Finance" user_type="super_admin" child="Payment History" onChildMessage={handleChildMessage}/>
      <div
        className={`main-content ${collapsed ? "collapsed" : ""}`}
        onScroll={(e) => handleContentScroll(e)}
      >
        {/* header bar */}
        <section className="header-bar">
          <div className="row align-items-center">
            <div className="col-xl-5 col-md-12 col-2">
              <div className="property-item">
                <div className="property-img">
                  <img src="/assets/admin/img/property.png" alt="" />
                </div>
                <div
                  className="property-select p-2 w-100 account-switcher-dropdown"
                  onMouseEnter={handePropertyDropdown}
                  onMouseLeave={handePropertyDropdown}
                >
                  <span className="property-switcher"> {propertyName} </span>
                  <div
                    className={`absolute text-gray-700 pt-1 z-50 w-100 p-2.5 h-40 bg-white overflow-y-scroll overflow-x-hidden ${
                      showPropertyDropdown ? "" : "hidden"
                    }`}
                    id="style-14"
                  >
                    <div className="ml-2 my-3 rounded-t bg-gray-200 py-2 px-4">
                      <span>Properties: </span>
                    </div>
                    {propertyOptions.map((v, i) => (
                      <div key={i} className="ml-2">
                        <span
                          onClick={handlePropertyName}
                          className="rounded-t bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap text-decoration-none"
                        >
                          {v}
                        </span>
                      </div>
                    ))}
                    <div className="ml-2 my-3 rounded-t bg-gray-200 py-2 px-4">
                      <span>Staff: </span>
                    </div>
                    {staffOptions.map((v, i) => (
                      <div key={i} className="ml-2">
                        <span
                          onClick={handlePropertyName}
                          className="rounded-t bg-gray-200 hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap text-decoration-none"
                        >
                          {v}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="mobile-logo">
                <img
                  className="img-fluid logo-light"
                  src="/assets/admin/img/logo-light.png"
                  alt=""
                />
                <img
                  className="img-fluid logo-dark"
                  src="/assets/admin/img/logo-dark.png"
                  alt=""
                />
              </div>
            </div>
            <div className="col-xl-7 col-md-12 col-10">
              <div className="header-bar-right items-start">
                <ul className="header-icons">
                  <li className="dropdown">
                    <a
                      className="dropdown-toggle"
                      href="#"
                      role="button"
                      id="dropdownMenuLink1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src="/assets/svgs/system-language-l.svg"
                        className="p-2"
                        alt=""
                      />
                    </a>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuLink1"
                    >
                      <span className="triangle-arrow" />
                    </div>
                  </li>
                  <li className="dropdown">
                    <a
                      className="dropdown-toggle"
                      href="#"
                      role="button"
                      id="dropdownMenuLink2"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src="/assets/svgs/system-activity-stream-l.svg"
                        className="p-2"
                        alt=""
                      />
                    </a>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuLink1"
                    >
                      <span className="triangle-arrow" />
                    </div>
                  </li>
                  <li className="dropdown">
                    <a
                      className="dropdown-toggle"
                      href="#"
                      role="button"
                      id="dropdownMenuLink3"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src="/assets/svgs/system-message-l.svg"
                        className="p-2"
                        alt=""
                      />
                    </a>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuLink2"
                    >
                      <span className="triangle-arrow" />
                    </div>
                  </li>
                  <li className="dropdown">
                    <a
                      className="dropdown-toggle"
                      href="#"
                      role="button"
                      id="dropdownMenuLink4"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img
                        src="/assets/svgs/system-notifications-l.svg"
                        className="p-2"
                        alt=""
                      />
                    </a>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuLink3"
                    >
                      <span className="triangle-arrow" />
                    </div>
                  </li>
                </ul>
                <ProfileSelect cookies={cookies} />
              </div>
            </div>
          </div>
        </section>
        {/* search wraper  */}
        <section className="search-wraper">
          <div className="row">
            <div className="col-xl-8 order-lg-2">
              <div className="search-right-side-wrap">
                <div className="mobile-menu-trigger">
                  <span />
                  <span />
                  <span />
                </div>
                <div className="serch-bar-side">
                  <div className="form-group search">
                    <input
                      type="search"
                      name
                      id
                      placeholder="Type here to Search..."
                    />
                    <i className="fas fa-search" />
                  </div>
                </div>
                <label className="theme-switch">
                  <span className="switch-dark">dark</span>
                  <input type="checkbox" id="check-slider" />
                  <span className="check-slider round" />
                  <span className="switch-light">light</span>
                </label>
              </div>
            </div>
            <div className="col-xl-4 order-lg-1">
              <div
                className={`welcome-wrap ${showPropertyDropdown ? "z-0" : ""}`}
              >
                <div className="welcome-inner">
                  <h4>
                    Welcome Back <span>Anddy’s Makeover</span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* service wraper */}
        <section>
          <div className="flex justify-between align-items-center">
            <div className="flex justify-between align-items-center">
              <img
                className="logo w-12 mr-5"
                src="/assets/svgs/finance-budget.png"
                alt=""
              />
              <h2 className="text-3xl font-bold text-black py-3">
                Purchase Orders
              </h2>
            </div>

            <button
              class="bg-gray-300 py-1 mr-2  w-64 flex justify-center align-items-center rounded text-black-800"
              data-bs-toggle="modal"
              data-bs-target="#exampleModalLg"
            >
              <span>Add purchase order</span>
            </button>

            <div
              class="modal fade fixed top-0 left-0 w-full h-full  outline-none overflow-x-hidden overflow-y-auto"
              id="exampleModalLg"
              tabindex="-1"
              aria-labelledby="exampleModalLgLabel"
              aria-modal="true"
              aria-hidden="true"
              role="dialog"
            >
              <div class="modal-dialog modal-xl relative w-auto pointer-events-none">
                <div class="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                  <div class="modal-header flex flex-shrink-0 items-center justify-between p-4 border-b border-gray-200 rounded-t-md">
                    {/* <h5
                      class="text-xl font-medium leading-normal text-gray-800"
                      id="exampleModalLgLabel"
                    >
                      Add Role
                    </h5> */}
                    <button
                      type="button"
                      class="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body relative pb-4 pt-2 px-4">
                    <div className="flex  align-items-center">
                      <img
                        className="logo w-12 mr-5"
                        src="/assets/svgs/finance-budget.png"
                        alt=""
                      />
                      <h2 className="text-3xl font-bold text-black py-3">
                        Add a purchase order
                      </h2>
                    </div>
                    <form className="w-full" id="add-property-form">
                      <div className="md:flex md:items-center gap-3 w-full mt-6">
                        <div className="md:w-5/12 md:flex items-center gap-3">
                          <label className="w-1/4 block capitalize text-gray-700 font-bold mb-2">
                            Number:
                          </label>
                          <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="hoa_zip_code-property-name"
                            type="text"
                            required={true}
                            value="Autogenrated"
                            // placeholder="Amount"
                          />
                        </div>
                        <div className="md:w-2/5 md:flex items-center gap-3">
                          <label className="w-1/4 block capitalize text-gray-700 font-bold mb-2">
                            Status:
                          </label>
                          <select
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            aria-label=".form-select-lg example"
                          >
                            <option selected>Type</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                          </select>
                        </div>
                      </div>
                      <div className="md:flex md:items-center gap-3 w-full mt-6">
                        <div className="md:w-5/12 md:flex items-center gap-3">
                          <label className="w-1/4 block capitalize text-gray-700 font-bold mb-2">
                            Date:
                          </label>
                          <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="hoa_zip_code-property-name"
                            type="date"
                            required={true}
                            value="Autogenrated"
                            // placeholder="Amount"
                          />
                        </div>
                      </div>
                      <div className="md:flex md:items-center gap-3 w-full mt-6">
                        <div className="md:w-5/12 md:flex items-center gap-3">
                          <label className="w-1/4 block capitalize text-gray-700 font-bold mb-2">
                            Title:
                          </label>
                          <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="hoa_zip_code-property-name"
                            type="text"
                            required={true}
                            value="Autogenrated"
                            // placeholder="Amount"
                          />
                        </div>
                        <div className="md:w-2/5 md:flex items-center gap-3">
                          <label className="w-1/4 block capitalize text-gray-700 font-bold mb-2">
                            Vendor:
                          </label>
                          <select
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            aria-label=".form-select-lg example"
                          >
                            <option selected>Type</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                          </select>
                        </div>
                      </div>
                      <div className="md:flex md:items-center gap-3 w-full mt-6">
                        <div className="md:w-5/12 md:flex items-center gap-3">
                          <label className="w-1/4 block capitalize text-gray-700 font-bold mb-2">
                            Amount Authorized:
                          </label>
                          <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            id="hoa_zip_code-property-name"
                            type="text"
                            required={true}
                            value="Autogenrated"
                            // placeholder="Amount"
                          />
                        </div>
                        <div className="md:w-2/5 md:flex items-center gap-3">
                          <label className="w-1/4 block capitalize text-gray-700 font-bold mb-2">
                            Budget:
                          </label>
                          <select
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            aria-label=".form-select-lg example"
                          >
                            <option selected>Type</option>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                          </select>
                        </div>
                      </div>
                      {/* <div className="md:flex md:items-center gap-3 w-full mt-6">
                        <div className="md:flex md:items-center w-full gap-4 w-full mt-6">
                          <div className="md:w-full md:flex gap-3 mb-3  ">
                            <label className="block capitalize text-gray-700 font-bold mb-2">
                              Transaction Notes
                            </label>
                            <div className="w-100">
                              <CKEditor
                                initData={""}
                                // disabled
                                // value={contact?.info}
                              />
                            </div>
                          </div>
                        </div>
                      </div> */}

                  
                      <div className="md:flex md:items-center gap-3 w-full mt-6">
                        <div className="md:flex md:items-center w-full gap-4 w-full ">
                          <div className="md:w-full md:flex gap-3 mb-3  ">
                            <label className="block capitalize text-gray-700 font-bold mb-2">
                              Transaction Notes
                            </label>
                            <div className="w-100">
                              <CKEditor
                                initData={""}
                                // disabled
                                // value={contact?.info}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                   
                      <div className="flex justify-content-end mt-4">
                        <input
                          id={"form-submit-button"}
                          type={"submit"}
                          value="Save"
                          hidden={false}
                          className="py-3 px-10 border-solid border-2  border-red-200 rounded"
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <DataTable
          columns={columns}
          data={userRoles}
          pagination
          fixedHeader
          fixedHeaderScrollHeight="500px"
          selectableRows
          selectableRowsHighlight
          highlightOnHover
          responsive
          sortable={true}
          defaultSortFieldId={1}
        />

        <div className="bottom-gap" />
      </div>
      <Footer />
    </div>
  );
};
